export const priceToNumber = (s?: string) => {
  if (!s) return NaN;
  return +(s.replace(",", "."))
}